import * as React from 'react';

// tslint:disable:max-line-length
export const FireIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      fillRule="nonzero"
      d="M9.724 6.293S10.47 1.905 7.426 0A5.37 5.37 0 0 1 5.4 3.887C4.1 5.03 1.655 7.6 1.681 10.34A6.285 6.285 0 0 0 5.132 16a3.984 3.984 0 0 1 1.394-2.755 3.253 3.253 0 0 0 1.246-2.185 5.856 5.856 0 0 1 3.1 4.881v.013a5.883 5.883 0 0 0 3.428-5.106c.216-2.574-1.194-6.074-2.445-7.218a6.793 6.793 0 0 1-2.131 2.663z"
    />
  </svg>
);
